import axios from "axios";
import { getSession } from "../authActions";
import { Apis, BaseUrl } from "../../config";
import { toast } from "react-toastify";

export const getPatientList = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "get_Patients_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}svcUserPro/${user_profile_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { sys_user_id: user_profile_id, role_id: role_id }

      },

    );
    dispatch({ type: "get_Patients_sucesss", payload: response.data });

  } catch (error) {
    dispatch({
      type: "get_Patients_failure",
      payload: error.response.data,
    });
  }
};
export const editPatient = (values, patientId) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_patient_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.newPatientList}${patientId}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_patient_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_patient_failure",
      payload: error.response.data,
    });

    //toast.error(error.response.data.usr.message);
  }
};
export const addPatients = (values, history) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_patient_req" });
  try {
    const response = await axios.post(`${BaseUrl}svcUserPro`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_patient_Sucess", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_patient_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};
export const setCurrentDataService = (data) => (dispatch) => {
  dispatch({ type: "set_Current_ser_details", payload: data });
};

export const setBookingData = (booking) => (dispatch) => {
  dispatch({ type: "set_Booking_Details", payload: booking });
};
